<template>
  <l-map
    ref="map"
    :center="centerLatLng"
    :max-zoom="20"
    :options="mapOptions"
    :style="style"
    :zoom="internalZoom"
    style="width: 100%"
    @update:center="centerUpdate"
    @update:zoom="zoomUpdate"
  >
    <l-tile-layer :options="{ maxNativeZoom: 19, maxZoom: 20 }" :url="url" />
    <l-marker v-for="marker in identifiedMarkers" :key="marker.id" :lat-lng="marker.coords">
      <l-icon>
        <svg
          class="image"
          height="42"
          viewBox="0 0 48 48"
          width="42"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            :fill="marker.color"
            d="M24 0c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z"
          />
        </svg>
        <span class="text">
          {{ marker.label }}
        </span>
      </l-icon>
    </l-marker>
    <l-polyline
      v-for="polyline in identifiedPolylines"
      :key="polyline.id"
      :color="polyline.color"
      :lat-lngs="polyline.coords"
    />
  </l-map>
</template>
<script>
import { latLng } from "leaflet";
import { LIcon, LMap, LMarker, LPolyline, LTileLayer } from "vue2-leaflet";
import { identify } from "@/utils/arrays";

export default {
  name: "markers-polylines-map",

  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPolyline,
    LIcon,
  },
  props: {
    markers: Array,
    polylines: Array,
    zoom: Number,
    center: Array,
    height: {
      type: String,
      default: "500px",
    },
  },

  data() {
    return {
      internalZoom: 13,
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      currentZoom: 11.5,
      currentCenter: location,
      centerLatLng: latLng(0, 0),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
    };
  },

  computed: {
    style() {
      return {
        height: this.height,
      };
    },
    identifiedPolylines() {
      return identify(this.polylines);
    },
    identifiedMarkers() {
      return identify(this.markers);
    },
  },

  watch: {
    center() {
      this.centerLatLng = latLng(this.center[0], this.center[1]);
    },
  },

  created() {
    this.internalZoom = this.zoom || this.internalZoom;
    this.centerLatLng = latLng(this.center ? this.center[0] : 0, this.center ? this.center[1] : 0);
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .leaflet-marker-icon {
  .image {
    transform: translate(-15px, -34px);
    filter: drop-shadow(0 3px 4px rgba(0, 0, 0, 0.4));
  }

  .text {
    position: absolute;
    transform: translate(-9px, -72px);
    width: 30px;
    text-align: center;
    color: white;
    font-weight: bold;
    text-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
    font-size: 11px;
  }
}
</style>
